<template>
	<page>
		<module :title="id ? '编辑商家角色' : '新建商家角色'">
			<template slot="button">
				<c-button size="m" @click="submit">提交保存</c-button>
			</template>

            <c-form ref="form">
                <c-form-item type="hidden" label="商家类型" name="stationed_type" value="1"></c-form-item>
                <c-form-item type="input" label="商家角色名称" name="auth_name" required></c-form-item>
                <c-form-item type="radio" label="发布商品审核" name="is_product_check" :options="checkOptions" :value="2" word="" required></c-form-item>
                <c-form-item type="radio" v-model="operationMode" label="运营模式" name="operation_mode" :options="operationModeOptions" :word="operationModeWord" required></c-form-item>
                <c-form-item type="radio" v-model="settlement_account_type" label="结算账户类型" name="settlement_account_type" :options="settlementAccountType"  :word="settlementAccountTypeWord" required :disabled = "issettlement_account_type_disabled"></c-form-item>
                <c-form-item type="radio" v-model="is_open_shop" label="是否开通店铺" name="is_open_shop" :options="isOpenShopOptions" :word="openShopWord" required :disabled = "isis_open_shop_disabled"></c-form-item>
                <c-form-item type="radio" v-model="profitModel" label="平台盈利模式" name="platform_profit_model" :options="profitModelOptions" :word="profitModelWord" required :disabled = "operationMode==3"></c-form-item>
                <c-form-item label="权限配置" >
                    <power-tree :power-list="powerList"></power-tree>
                </c-form-item>
                <c-form-item type="textarea" label="备注" name="remark"></c-form-item>
            </c-form>
        </module>
	</page>
</template>

<script>
	function renderPower(h, list, parent) {
		var arr = [], last = !list.find(item => item.children.length);
		list.map(item => {
			item.parent = parent;
			
			arr = arr.concat([
				<div class="power-item" style={`float: ${last ? 'left' : 'none'}`}>
					<c-checkbox checked={item.chk != 0} on-click={$event => this.checkHandle(item, $event)}>{item.name}</c-checkbox>
					{
						item.children.length ? [
							<div class="power-list">
								{
									renderPower.call(this, h, item.children, item)
								}
							</div>
						] : []
					}
				</div>
			]);
		});
		
		return arr;
	}
	
	const powerTree = {
		render(h) {
			return (
				<div class="power">
					{
						renderPower.call(this, h, this.powerList)
					}
				</div>
			)
		},
		
		props: {
			powerList: Array
		},
		
		methods: {
			checkHandle(power, state) {
				state = state ? 1 : 0;
				
				power.chk = state;
				!function poll(list) {
					list.forEach(item => {
						item.chk = state;
						poll(item.children);
					});
				}(power.children);
				
				!function poll(parent) {
					if (parent) {
						parent.chk = parent.children.find(item => !!item.chk) ? 1 : 0;
						poll(parent.parent);
					}
				}(power.parent);
			}
		}
	};
	
	export default {
		name: 'stationed_auth_edit',
		
		components: {
			powerTree
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				is_firest: true,
				operationMode: 1,               //运营模式
                profitModel: 1,                 //盈利模式
				is_open_shop: 1,
				issettlement_account_type_disabled: false,
				isis_open_shop_disabled: true,
				settlement_account_type: 1,
				powerList: [],
				checkOptions: [{
					name: '不需要',
					value: 1
				}, {
					name: '需要',
					value: 2
				}],
				profitModelOptions: [
                    {name: '向商家抽取服务费', value: 1},
                    {name: '平台加价销售', value: 2}
                ],
				isOpenShopOptions: [
                    {name: '无店铺',value: 1},
                    {name: '开通店铺',value: 2}
                ],
				operationModeOptions: [
                     {name: '平台运营',value: 1},
                     {name: '商家自营',value: 2}
                ],
				settlementAccountType: [{
					name: '平台统收账户',
					value: 1
				},{
					name: '商家独立账户',
					value: 2
				}]
			}
		},

        computed: {
            operationModeWord() {
                return {
                    1: '商品归属平台，商家无需关注商品在平台的销售；不同商家的商品同时下单将合并为一个订单，订单由平台统一发货;平台根据商品的报价给商家结算相关费用。',
                    2: '商品归属其自身，不同商家的商品同时在平台下单时，将按照商品所属的商家拆分不同订单；商家需要自行完成订单发货，平台仅收取部分服务费用。',
                    3: '商家仅作为平台的供货商，客户在平台下单与商家无关，平台需要向商家下单采购相关商品'
                }[this.operationMode]
            },
            settlementAccountTypeWord(){
                return {
                    1: '所有费用先结算到平台的统一账户中，再线下结算给商家。',
                    2: '相关商家应得费用结算给商家的独立账户，商家可以通过提现方式将资金提现。'
                }[this.settlement_account_type]
            },
            openShopWord(){
                return {
                    1: '不允许在平台上单独开店。',
                    2: '可以在平台上单独开店，并对店铺进行部分自定义装修。'
                }[this.is_open_shop]
            },
            profitModelWord(){
                return {
                    1: '根据商家配置的全部服务费比例，按照订单金额收取服务费用，从订单收益中减去服务费，剩余费用结算给商家',
                    2: '在商家发布的商品单价上进行加价销售，加价费用作为平台盈利。'
                }[this.profitModel]
            }
        },
		
		watch: {
			id() {
				this.update();
			},
			operationMode() {
				if(!this.id){
					this.is_firest = false;
				}
				if(this.operationMode == 1){//平台运营
					if(!this.is_firest){
						this.settlement_account_type = 1;
						this.is_open_shop = 1;
					}
					this.issettlement_account_type_disabled = false;
					this.isis_open_shop_disabled = true;
				}else if(this.operationMode == 2){//商家自营
					if(!this.is_firest){
						this.settlement_account_type = 2;
						this.is_open_shop = 2;
					}
					this.issettlement_account_type_disabled = true;
					this.isis_open_shop_disabled = false;
				}else if(this.operationMode == 3){//采购供货
                    this.settlement_account_type = 1;
                    this.is_open_shop = 1;
                    this.profitModel = 2;
                    this.issettlement_account_type_disabled = true;
                    this.isis_open_shop_disabled = true;
                }
				this.is_firest = false;
			}
		},
		
		mounted() {
			this.update();
		},
		
		methods: {
			update() {
				this.request({
					url: '/stationed/auth/detail',
					data: {
						auth_id: this.id || 0,
                        stationed_type:1                //商家（S端商家）
                    },
					success: data => {
						if (this.id) {
							// this.operationMode = data.info.operationMode;
							this.settlement_account_type = data.info.settlement_account_type;
							this.is_open_shop = data.is_open_shop;
							
							this.$refs.form.set(data.info);
						}
						this.powerList = data.auth_menu;
					}
				});
			},
			
			submit() {
				this.$refs.form.submit({
					url: this.id ? '/stationed/auth/edit' : '/stationed/auth/add',
					rule: {
						auth_name: '请填写商家角色名称',
						operation_mode: '请选择运营模式',
						settlement_account_type: '请选择结算账户类型'
					},
					dataFormatter: data => {
						data.auth_id = this.id;
						data.auth_menus = [];
						!function poll(list) {
							list.forEach(item => {
								if (item.chk) {
									data.auth_menus.push({
										menu_id: item.id
									});
								}
								poll(item.children);
							});
						}(this.powerList);
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '保存成功'
						});
						this.$bus.$emit('authList.update', this.id ? undefined : 1);
						this.redirectTo('/stationed_auth_list');
					},
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .power {
		max-height: 500px;
		border: 1px solid #ddd;
		overflow: auto;
			
		&-list {
			margin-left: 40px;
			overflow: hidden;
		}
		
		> &-item {
			margin-left: 20px;
			
			&:nth-last-child(1) {
				margin-bottom: 15px;
			}
		}
		
		&-item {
			margin-top: 15px;
			margin-right: 20px;
		}
	}
</style>